import React from "react";
import { FaJs, FaNodeJs, FaReact, FaPython, FaVuejs } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";

/* ========== helpers ========== */
const InfiniteSlider = ({ children, duration = 24, reverse = false }) => (
  <div className="overflow-hidden w-full h-full">
    <div
      className="flex items-center whitespace-nowrap"
      style={{
        animation: `${reverse ? "marquee-rev" : "marquee"} ${duration}s linear infinite`,
        width: "max-content",
        gap: "clamp(18px,2.2vw,36px)",
        paddingInline: "clamp(28px,4vw,64px)",
      }}
    >
      {children}
      {children}
      {children}
    </div>
  </div>
);

const Badge = ({ icon: Icon, name }) => (
  <div className="flex items-center gap-3 px-4 py-3">
    <Icon className="w-[clamp(18px,2.1vw,22px)] h-[clamp(18px,2.1vw,22px)] text-black" />
    <span className="font-extrabold tracking-wider text-black text-[clamp(14px,1.45vw,18px)]">
      {name}
    </span>
  </div>
);

/* ========== main section ========== */
const ServicesSection = () => {
  const tech = [
    { icon: FaJs, name: "JAVASCRIPT" },
    { icon: SiNextdotjs, name: "NEXT.JS" },
    { icon: FaNodeJs, name: "NODE.JS" },
    { icon: FaReact, name: "REACT.JS" },
    { icon: FaVuejs, name: "VUE.JS" },
    { icon: FaPython, name: "PYTHON" },
  ];



  return (
    <section
      className="relative overflow-hidden"
      style={{
        background: "#EDEBDD",
        height: "clamp(260px, 38vw, 420px)",
        "--ribbon-h": "clamp(60px, 8vw, 80px)",
        "--angle": "12deg",
        "--border": "3px",
      }}
    >
     

      {/* TOP RIBBON — diagonal from top-right to bottom-left */}
      <div
        className="absolute flex items-center"
        style={{
          top: "35%",
          right: "-30%",
          width: "200%",
          height: "var(--ribbon-h)",
          background: "#fff",
          border: "var(--border) solid #630000",
          boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
          transform: "rotate(-8deg)",
          transformOrigin: "center",
          zIndex: 2,
        }}
      >
        <InfiniteSlider duration={22}>
          {tech.map((t, i) => (
            <Badge key={`top-${i}`} icon={t.icon} name={t.name} />
          ))}
        </InfiniteSlider>
      </div>

      {/* BOTTOM RIBBON — diagonal from bottom-left to top-right (reverse direction) */}
      <div
        className="absolute flex items-center"
        style={{
          bottom: "35%",
          left: "-30%",
          width: "200%",
          height: "var(--ribbon-h)",
          background: "#fff",
          border: "var(--border) solid #630000",
          boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
          transform: "rotate(8deg)",
          transformOrigin: "center",
          zIndex: 1,
        }}
      >
        <InfiniteSlider duration={26} reverse>
          {tech.map((t, i) => (
            <Badge key={`bottom-${i}`} icon={t.icon} name={t.name} />
          ))}
        </InfiniteSlider>
      </div>

      {/* animations */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        @keyframes marquee-rev {
          0% { transform: translateX(-33.333%); }
          100% { transform: translateX(0); }
        }
        @media (max-width: 640px) {
          section[style*="--ribbon-h"] > div {
            border-width: 2px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;